













































































import { computed, defineComponent } from '@vue/composition-api'
import { useCreateLeadForm } from '@/composables/useCreateLeadForm'
import { usePostcodeApi } from '@/composables/usePostcodeApi'
import { useGender } from '@/composables/useGender'
import { useComment } from '@/composables/useComment'
import { Contact } from '@/api/model/contact'

export default defineComponent({
    name: 'CreateLeadFormStep4',
    setup() {
        const { state, mentionableUsers } = useCreateLeadForm()
        const { genderOptions } = useGender()
        const { commentVisibilityOptions } = useComment()
        const contact = computed<Contact>(() => state.referral.contact as Contact)

        const postcodeApi = usePostcodeApi()
        const fetchingZipcodeData = computed(() => postcodeApi.loading.value)
        const validZipcodeData = computed(() => postcodeApi.hasResult.value)

        async function checkSpouseZipcode() {
            if (!contact.value.spouseZipcode || contact.value.spouseZipcode.length < 6) {
                return
            }

            if (!contact.value.spouseStreetnumber || contact.value.spouseStreetnumber.length === 0) {
                return
            }

            const regex = /[0-9]{4}(?:\s?[a-zA-Z]{2})?/g

            if (contact.value.spouseZipcode.match(regex) !== null) {
                contact.value.spouseZipcode = contact.value.spouseZipcode.replaceAll(/\s/g, '')
            } else {
                postcodeApi.reset()
                return
            }

            const result = await postcodeApi.search(
                contact.value.spouseZipcode,
                contact.value.spouseStreetnumber,
            )

            if (result.length > 0) {
                contact.value.spouseZipcode = result[0].postcode
                contact.value.spouseStreetname = result[0].street
                contact.value.spouseCity = result[0].city?.label
                contact.value.spouseCountry = 'Nederland'
            }
        }

        return {
            state,
            contact,
            genderOptions,
            commentVisibilityOptions,
            mentionableUsers,

            fetchingZipcodeData,
            validZipcodeData,
            checkSpouseZipcode,
        }
    },
})
